var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none'],attrs:{"data-test":_vm.dataTest}},[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id
    },false)):_vm._e(),(_vm.readOnly)?_c('div',[_vm._v("\n    "+_vm._s(_vm.symbol)+" "+_vm._s(_vm.value)+"\n  ")]):_c('div',{staticClass:"d-flex position-relative"},[_c('div',{staticClass:"position-absolute px-2 align-self-center text-muted",staticStyle:{"font-size":"16px","line-height":"16px","padding-top":"1px","left":"2px"},attrs:{"data-test":"symbol"},on:{"click":function($event){return _vm.focus()}}},[_vm._v("\n      "+_vm._s(_vm.symbol)+"\n    ")]),_c('input',_vm._g(_vm._b({ref:"input",class:[
        'form-control',
        'pl-4',
        _vm.disabled && 'p-0' ],attrs:{"id":_vm.id,"type":"number","placeholder":_vm.disabled ? '—' : _vm.placeholder,"disabled":_vm.disabled,"invalid":_vm.invalid && _vm.dirty},domProps:{"value":_vm.value}},'input',_vm.minMaxStepConfig,false),_vm.inputListners))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }